import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getManualList = async (e_line, cur_page,groupId) => {
  const requestBody = {
    e_line,
    cur_page,
    menu: "M:"+groupId,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectManualList`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getManual = async (no) => {
  const requestBody = {
    no,
 //   file_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/selectManual`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertManualInfo = async (e,groupId) => {
  const formData = new FormData();

  let usedScope = 'M';
  if (e.used_scope === '2'){
    usedScope = 'M:'+groupId;
  }

  formData.append("title", e.title);
 // formData.append("menu", "M");
  formData.append("menu", usedScope);
  formData.append("file", e.file);
  try {
    const response = await httpRequest(
      "post",
      `${URL}/insertManualInfo`,
      formData
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateManualInfo = async (e,groupId) => {
  const formData = new FormData();
  let usedScope = 'M';

  if (e.used_scope === '2'){
    usedScope = 'M:'+groupId;
  }

  formData.append("menu", usedScope);
  formData.append("file_id", e.file_id);
  formData.append("title", e.title);
  formData.append("no", e.no);

  try {
    const response = await httpRequest(
      "post",
      `${URL}/updateManualInfo`,
      formData
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteManualInfo = async (no) => {
  const requestBody = {
    no,
//    file_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/deleteManualInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
